import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { LocalstorageService } from "src/services/core/localstorage/localstorage.service";
import { ToastService } from "src/services/core/toast/toast.service";
import { Config } from "../config";
import { ToastTypes } from "../enums/ToastTypes";
import { ErrorTranslations } from "../error/errorTranslations";

const ErrorHelperFunctions = {
    translateFunction: function(error: HttpErrorResponse, toastr: ToastService, router: Router, language: string = 'bg', localstorage: LocalstorageService | null = null) {
        let errorDetected = error?.error?.data?.errors;
        let toastTranslation: any = null;
        if (!errorDetected) {
            errorDetected = error?.error?.message;
            toastTranslation = ErrorTranslations.translate(errorDetected, language);
        }
        else {
            toastTranslation = ErrorTranslations.translate(errorDetected[Object.keys(errorDetected)[0]][0], language);
        }

        switch (toastTranslation.type) {
            case ToastTypes.SUCCESS:
                toastr.success(toastTranslation.text)
                break;
            case ToastTypes.WARNING:
                toastr.info(toastTranslation.text)
                break;
            default:
                toastr.error(toastTranslation.text)
                break;
        }
    },
}

export const Errors = {

    statuses: {
        '422': ErrorHelperFunctions.translateFunction,
        '400': ErrorHelperFunctions.translateFunction,
        '409': function(error: HttpErrorResponse, toastr: ToastService, router: Router, language: string = 'bg', localstorage: LocalstorageService | null = null) {
            toastr.error(Errors.responseCatchedErrors[409][language as keyof typeof Errors.responseCatchedErrors[409]]);
        },
        '401': function(error: HttpErrorResponse, toastr: ToastService, router: Router, language: string = 'bg', localstorage: LocalstorageService | null = null) {
            const url = error.url;
            if (Errors.responseCatchedErrors[401][url as keyof typeof Errors.responseCatchedErrors[401]]) {
                toastr.error(Errors.responseCatchedErrors[401][url as keyof typeof Errors.responseCatchedErrors[401]][language as keyof typeof Errors.responseCatchedErrors[409]]);
            }
            else {
                toastr.error(Errors.responseCatchedErrors[401].default[language as keyof typeof Errors.responseCatchedErrors[409]]);
            }
            if (localstorage) {
                localstorage.removeLocalStorageItem(Config.lsTokenKey);
            }
            router.navigate(['login']);
        },
        default: function(error: HttpErrorResponse, toastr: ToastService, router: Router, language: string = 'bg') {
            return Errors.default[language as keyof typeof Errors.default];
        },
    },
    responseCatchedErrors: {
        '401': {
            'https://test-api.shareme.co/v1/user/auth/login': {
                bg: "Невалидни потребител или парола",
                en: "Invalid credentials"
            },
            default: {
                bg: "Изтекла сесия",
                en: "Registration timed out",
            }
        },
        '409': {
            bg: 'Въвели сте грешна стара парола'
        }
    },
    userexists : {
        bg: "Такъв потребител вече съществува",
        en: "Such user already exists"
    },
    imageUpload: {
        bg: "Качването на снимката е неуспешно",
        en: "The image was uploaded unsuccessful"
    },
    imageType: {
        bg: "Типът на снимката не се поддържа",
        en: "The image extension is invalid"
    },
    imageMaxAmount: {
        bg: "Можете да добавите до 8 снимки",
        en: "You can add upp to 8 pictures only"
    },
    imageMaxSize: {
        bg: " надхвърля 8 мегабайта",
        en: " exceeds 8 megabytes"
    },
    default: {
        en: "There is a problem with the system. Contact the support.",
        bg: "Има грешка със системата. Свържете се с екипа за поддръжка."
    },

    errrorPages: {
        resourceNotFound:
        {
            en: {
                title: 'Item not found',
                description: 'Cannot find your item. Your link is invalid.',
                help: 'Call the support for more information.'
            },
            bg: {
                title: 'Артикулът не е намерен',
                description: 'Не можем да намерим вашият артикул. Може би линкът не е валиден.',
                help: 'Обърнете се към екипа за поддръжка за повече информация.'
            }
        }
    },

    passwordMatch: {
        en: "Your password confirmation is invalid",
        bg: "Новите пароли не съвпадат"
    },

    duplicateOrganisation: {
        bulstat: {
            bg: "Фирма с това ЕИК/Булстат е вече регистрирана"
        },
        vat: {
            bg: "Фирма с такъв ДДС номер е вече регистрирана"
        }
    },

    bg: {
        generic: "Има временен проблем със приложението",
        invalidField: ' е невалиден/на/но !',
        passwordMatch: 'Паролите не съвпадат',
        invalidFields: 'Моля въведете правилно всички полета.',
        invalidEmail: 'Форматът на имейла е невалиден !',
        imageUpload: "Качването на снимката е неуспешно",
        imageType: "Типът на снимката не се поддържа",
        imageMaxAmount: "Можете да добавите до 8 снимки",
        imageMaxSize: "Снимката надхвърля 8 мегабайта",
        noConnectivity: "Нямате достъп до интернет",
        getContactsError: "Не можахме да осъществим достъп до конактите Ви!",
        productLoad: 'В момента не можем да заредим продуктите!',
        singleProductLoad: 'В момента не можем да заредим продукта!',
        partnerLoad: 'В момента не можем да заредим партньора!',
        imagesLoad: 'В момента не можем да заредим изображенията!',
        categoryLoad: 'В момента не можем да заредим категориите!',
        unauthenticated: 'Не сте се вписали в приложението или регистрацията Ви е изтекла!',
        cartLoad: 'В момента не можем да заредим количката!',
        cartCreate: 'В момента не можем да създадем количката!',
        addToCart: 'В момента не можем да добавим продукта към количката!',
        updateCartLine: 'В момента не можем да обработим вашата промяна!',
        cannotSaveCard: "В момента не можем да запазим вашата карта",
        cannotSaveAddress: "В момента не можем да запазим вашия адрес",
        cardLoad: 'В момента не можем да заредим вашите карти!',
        adressLoad: 'В момента не можем да заредим вашите адреси!',
        cannotLoadAddress: "В момента не можем да заредим адресите",
        orderLoad: "В момента не можем да заредим поръчката",
        logosLoad: 'В момента не можем да заредим логото!',
        ratingsLoad: 'В момента не можем да заредим рейтингите!',
        groupsLoad: 'В момента не можем да заредим групите!',
        groupLoad: 'В момента не можем да заредим групата!',
        quantityOverflowError: 'Заявеното количество надвишава текущото',
        cardHolderIsInvalid: 'Въведете име на картодържателя',
        ratingNotFilled: 'Въведете рейтинг за продукта!'

    }
}
